import UserStore from '../../reverb-js-common/user_store';
import UrlHelpers from './url_helpers';

// Appends the user's country code to a given URL
// i.e. /marketplace -> /uk/marketplace

export default (url) => {
  const { countryCode } = UserStore.getState();

  return UrlHelpers.urlByRegion(url, countryCode);
};



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/shared/user_region_url.js